export const AIF_UNITS = [
  'aif1-2025',
  'aif2-2025',
  'aif3-2025',
  'aif4-2025',
  'aif5-2025',
  'aif6-2025',
];
